import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { NewCustomerPage } from '../../../features/customers/customer-edit-pages'
import { customerGroupsQueryOptions } from '../../../features/customers/queries'

export const Route = createFileRoute('/_app/customers/new')({
  staticData: { crumb: 'customerNew' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'customers.create'),
  loader: ({ context }) => {
    // Warm the group picker; the form does not wait for it.
    void context.queryClient.prefetchQuery(customerGroupsQueryOptions)
  },
  component: NewCustomerPage,
})
